export const SSO_LOGIN = "SSO_LOGIN";